import React from 'react';
export function Rotate() {
  return <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 98.666 98.666"
  // @ts-expect-error todo(ts-migration) TS2322 Type '{ enableBackground: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
  style={{
    enableBackground: 'new 0 0 98.666 98.666'
  }} xmlSpace="preserve" fill="currentColor">
      <g>
        <g>
          <path d="M84.271,42.357c-0.158,0.604-0.626,1.08-1.229,1.246c-0.153,0.041-0.31,0.062-0.465,0.062
			c-0.453,0-0.896-0.177-1.229-0.504L70.201,32.163c-0.445-0.439-0.623-1.083-0.465-1.688s0.626-1.08,1.229-1.246l1.562-0.429
			c-4.002-4.794-10.006-7.688-16.308-7.806c-0.954-0.018-1.717-0.797-1.717-1.75v-6.956c0-0.468,0.188-0.916,0.521-1.245
			s0.798-0.48,1.252-0.504c11.136,0.152,21.165,5.863,26.968,15.313l2.825-0.777c0.603-0.165,1.248,0.004,1.692,0.441
			c0.445,0.439,0.623,1.083,0.465,1.688L84.271,42.357z" fill="currentColor" />
          <path d="M0.105,2v73.701c0,1.104,0.896,2,2,2h18.754l-0.001,18.681c-0.013,0.093-0.02,0.188-0.02,0.284c0,1.104,0.896,2,2,2
			c0.006,0,0.013,0,0.02,0h73.703c1.104,0,2-0.896,2-2V50.105c0-1.104-0.896-2-2-2H50.666V2c0-1.104-0.896-2-2-2H2.105
			C1.001,0,0.105,0.896,0.105,2z M29.796,89.729V57.043h59.827v32.686H29.796z M20.859,50.105v18.658H9.042V8.937h32.686v39.169
			H22.859C21.755,48.106,20.859,49.002,20.859,50.105z" fill="currentColor" />
        </g>
      </g>
    </svg>;
}